<template>
  <div class="card" :class="getComputedCssClasses()">
    <div v-if="!!this.$slots['header']" class="card-header">
      <div class="d-flex justify-content-between">
        <slot name="header" />
        <button
          v-if="closable"
          class="btn-xs btn"
          type="button"
          data-bs-toggle="collapse"
          aria-expanded="false"
          :data-bs-target="`#${closeTriggerId}`"
          :aria-controls="closeTriggerId"
          @click="isCollapsed = !isCollapsed"
        >
          <i :class="collapseableIcon"></i>
        </button>
      </div>
    </div>
    <div
      v-if="!!this.$slots['body']"
      :id="closable ? closeTriggerId : false"
      :class="{ 'm-0 p-0': this.normalizeCardBody }"
      class="card-body"
    >
      <slot name="body" />
    </div>
    <div v-if="!!this.$slots['footer']" class="card-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import uniqid from "uniqid";

export default {
  props: {
    closeTriggerId: {
      type: String,
      default: () => uniqid("card-close-trigger-")
    },
    normalizeCardBody: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: false
    },
    startClosed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCollapsed: this.startClosed
    };
  },
  computed: {
    collapseableIcon() {
      const iconType = this.isCollapsed ? "collapse" : "expand";
      return `pf-sys-${iconType}-o`;
    }
  },
  methods: {
    getComputedCssClasses() {
      return [{ collapse: this.closable }, { show: !this.startClosed }];
    }
  }
};
</script>
